import Vue from 'expose-loader?exposes=Vue!vue';
import { Countdown } from './Countdown';
import { BasketCountBadge } from './components/BasketCountBadge';
import { DadataName } from './components/DadataName';
import { InputDadataAddress } from './components/DadataAddress';
import { CityChooser } from './components/CityChooser';
import * as InputPhoneMask from './components/InputPhoneMask';
import $ from 'jquery';
import 'select2';
import './DateMask';
import './DiscountPill';
import './ProductCardFavourite';
import './ZipCode';
import './bitrix-bridge/BX.mod';
import './modal-auth-by-email';
import './EmailCapsFilter';
import 'expose-loader?exposes=addFavourite|default!./bitrix-bridge/addFavourite';
import 'expose-loader?exposes=ReviewMoodControl!./bitrix-bridge/ReviewMoodControl';
import 'expose-loader?exposes=addToCart&exposes=changeButton!./functions/tocart';
import 'expose-loader?exposes=ModalAjax|ModalAjax!./components/ModalAjax';
import 'expose-loader?exposes=showReviewAgreements|showReviewAgreements!./components/ReviewAgreements';
import 'expose-loader?exposes=showReviewNotAllowed|showReviewNotAllowed!./components/ReviewNotAllowed';
import './BonusFAQForm';
import './service-map';
import './service-map-round-controls';
import './serviceAuth'
import './bitrix-bridge/smartFilter';
import './bitrix-bridge/addReview';
import './bitrix-bridge/addFavourite';
import './bitrix-bridge/BuyWith';
import getUserRules from './api/getUserRules';
import { getAbility } from './defineAbility';
import './functions/load-more';
import './functions/productDescriptionMore';

import './header-search';
import './header-catalogue';
import './header-catalogue-dropdown';
import './nav-mobile';
import './banner-carousel';
import './category-filter';
import './product-gallery';
import './files';

import './legacy/brands';
import './legacy/products';
import './legacy/modal-auth-by-phone';
import './legacy/request.new/script';
import './legacy/request.edit/script';
import './legacy/sale.location.search.selector/script';
import './MiniApp';
import './lang/ru';
import TableReports from '~/components/TableReports';
import FormReports from '~/components/FormReports';
import ListReports from '~/components/ListReports';
import ServiceCalls from '~/components/ServiceCalls';
import ServiceRequests from '~/components/ServiceRequests';
import SelectStatus from '~/components/SelectStatus';
import ActSearchForm from '~/components/ActSearchForm';
import StatusSearchForm from '~/components/StatusSearchForm';


Vue.component('countdown', Countdown);
Vue.component('basket-count-badge', BasketCountBadge);
Vue.component('dadata-name', DadataName);
Vue.component('input-dadata-address', InputDadataAddress);
Vue.component('city-chooser', CityChooser);
Vue.component('table-reports', TableReports);
Vue.component('form-reports', FormReports);
Vue.component('list-reports', ListReports);
Vue.component('service-calls', ServiceCalls);
Vue.component('service-requests', ServiceRequests);
Vue.component('select-status', SelectStatus);
Vue.component('act-search-form', ActSearchForm);
Vue.component('status-search-form', StatusSearchForm);
Vue.component('request-movement', () => import('./components/RequestMovement'));
Vue.component('incoming-request-movements-table',
	() => import('./components/RequestMovementsTable')
		.then(({ IncomingRequestMovementsTable }) => IncomingRequestMovementsTable));
Vue.component('outgoing-request-movements-table',
	() => import('./components/RequestMovementsTable')
		.then(({ OutgoingRequestMovementsTable }) => OutgoingRequestMovementsTable));

function initDateAndTimeControls() {
	// Функция инициализации переключателей даты и времени для оформления заказа
	$('input[data-target]')
		.change(function () {
			const $target = $($(this).data('target'));
			const $parent = $($target.data('parent'));
			const $children = $parent.find(`[data-parent='#${$parent.prop('id')}']`);

			$children
				.not($target)
				.hide()
				.find('input')
				.prop('disabled', true);

			$target
				.show()
				.find('input')
				.prop('disabled', false);
		});
}

global.initDateAndTimeControls = initDateAndTimeControls;

const userAbilities = getUserRules().then(rules => getAbility('crm', rules))

$(function () {
	// Init Vue timers
	$('.timer, [is="basket-count-badge"]').toArray().forEach(el => new Vue({ el }));
	InputPhoneMask.init();

	// Костыли
	$(() => {
		const inputCount = document.querySelector('input#filteredProductCount');
		const place = document.querySelector('input#filteredProductCountPlace');

		if (inputCount && place && !isNaN(Number(inputCount.value))) {
			place.innerText = inputCount.value;
		}
	});

	initDateAndTimeControls();
});
